var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('div',{attrs:{"id":"lchart"}},[_c('apexchart',{attrs:{"type":"line","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1),_c('v-card-text')],1)}
var staticRenderFns = []

export { render, staticRenderFns }